import type { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { Icon as CoreIcon } from '@scality/core-ui';
import type { IconName as CoreIconName } from '@scality/core-ui/dist/components/icon/Icon.component';
import type { ComponentProps } from 'react';
import { guardianIcons, type GuardianIconName } from './guardianIcons';

const SIZE_MAP: Partial<Record<SizeProp, string>> = {
  xs: '0.75rem',
  sm: '0.875rem',
  '1x': '1rem',
  lg: '1.25rem',
  '2x': '2rem',
  '3x': '3rem',
};

export type IconName = CoreIconName | GuardianIconName;

type Props = ComponentProps<typeof CoreIcon> & {
  name: IconName;
};

export function Icon({ name, size = '1x', ariaLabel, style, ...rest }: Props) {
  const src = guardianIcons[name as GuardianIconName];

  if (src) {
    const dimension = SIZE_MAP[size] ?? '1rem';
    return (
      <img
        src={src}
        aria-label={ariaLabel}
        aria-hidden={ariaLabel ? undefined : true}
        title={rest.title}
        onClick={rest.onClick}
        style={{ width: dimension, height: dimension, objectFit: 'contain', display: 'block', ...style }}
      />
    );
  }

  return (
    <CoreIcon
      name={name as CoreIconName}
      size={size}
      ariaLabel={ariaLabel}
      style={style}
      {...rest}
    />
  );
}
